export default __webpack_public_path__ + "locales/ar-SA/Files.json?hash=750c02873172ea1664b426ac96a3f9f0";